import { useFeatureFlags } from '../context/FeatureFlagsContext';

export enum FeatureFlags {
    NEW_MACU_LOGO = 'NEW_MACU_LOGO',
    PREFER_WEBP_IMAGES = 'PREFER_WEBP_IMAGES',
    PREFER_WEBP_IMAGES_CSS = 'PREFER_WEBP_IMAGES_CSS',
    ENABLE_SPANISH_HOMEPAGE = 'ENABLE_SPANISH_HOMEPAGE',
    ENABLE_BRANCHES_WAIT_TIMES = 'ENABLE_BRANCHES_WAIT_TIMES',
}

export const getFeatureFlag = (featureFlag: FeatureFlags) => {
    const featureFlags = useFeatureFlags();
    let parsedFeatureFlags = {};
    try {
        parsedFeatureFlags = typeof featureFlags === 'string' ? JSON.parse(featureFlags) : featureFlags;
    } catch (error) {
        console.error("error parsing featureFlags", error);
    }
  
    return parsedFeatureFlags[featureFlag] ?? false;
}
